import React, { Component } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useThemeChange } from "../../../../utils/themeChange";
class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return <div {...props}></div>;
  }
}

export default function ArtList(props) {
  const { arts } = props;
  const navigate = useNavigate();
  const themeChange = useThemeChange();

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: 300,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className={themeChange.add("section-2")}>
      <div className="nft-big">
        <Slider {...settings}>
          {arts?.length ? (
            arts?.map((item, index) => {
              return (
                <CustomSlide className="itm" index={index} key={index}>
                  <div
                    className="nft_pic"
                    onClick={() => navigate(`/license/${item?.id}`)}
                  >
                    <span>
                      <span className="nft_pic_info">
                        <span className="nft_pic_title">{item?.name} </span>
                        {item?.artist?.name && (
                          <span className="nft_pic_by">
                            <i className="fa fa-user"></i> {item.artist.name}
                          </span>
                        )}
                      </span>
                    </span>
                    <div className="nft_pic_wrap">
                      <img
                        src={item?.previewImage}
                        className="lazy img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </CustomSlide>
              );
            })
          ) : (
            <CustomSlide className="itm" index={1}>
              <div className="nft_pic">
                <span>
                  <span className="nft_pic_info">
                    <span className="nft_pic_title"></span>
                    <span className="nft_pic_by"></span>
                  </span>
                </span>
                <div className="nft_pic_wrap">
                  <img
                    src="./img/background/homepage.jpeg"
                    className="lazy img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </CustomSlide>
          )}
        </Slider>
      </div>
    </div>
  );
}
